import axiosInstance from "../interceptor/interceptor"; // Assuming axiosInstance is correctly configured
import dictionary from "../dictionary";

const { notifications } = dictionary;

const notificationsServices = {
  getNotifications: (body?: any) => axiosInstance.post(notifications.getNotifications(),body),
  readNotification: (body:any) => axiosInstance.put(notifications.updateReadNotification(),body),
};

export default notificationsServices;
